export default __webpack_public_path__ + "44f8f77ef4df78f35b5a7a7d20d2c682.png";